module.exports = __webpack_public_path__ + "static/media/ES.ac59a890.png";